var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_4002_3411)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 13.332L16.0004 9.33203L20.0004 13.332C20.7915 14.1231 21.3302 15.1311 21.5484 16.2283C21.7667 17.3256 21.6546 18.463 21.2265 19.4966C20.7983 20.5302 20.0733 21.4136 19.1431 22.0351C18.2128 22.6567 17.1192 22.9884 16.0004 22.9884C14.8817 22.9884 13.788 22.6567 12.8578 22.0351C11.9276 21.4136 11.2025 20.5302 10.7744 19.4966C10.3462 18.463 10.2342 17.3256 10.4524 16.2283C10.6706 15.1311 11.2094 14.1231 12.0004 13.332Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 20.6654C15.1172 20.6654 14.2694 20.3142 13.6443 19.6891C13.0192 19.0639 12.668 18.2161 12.668 17.332",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4002_3411",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDrop);
export default __webpack_public_path__ + "static/media/orange-drop.bdf0ed194022445b8a5138af6100b78e.svg";
export { ForwardRef as ReactComponent };